import { FormattedMessage } from 'react-intl';

export const CustomerWarningBlock = () => {
  return (
    <div>
      <div className={'rounded-2-5xl bg-main p-5'}>
        <div className={'background-red flex justify-between'}>
          <h3 className={'text-secondary font-satoshi-black my-0 inline-block flex-col text-base font-black'}>
            <div className={'flex flex-col gap-4'}>
              <p className={'m-0'}>
                <FormattedMessage id={'affordabilityCalculator.beforeStart.warning1'}></FormattedMessage>
              </p>
              <p className={'m-0'}>
                <FormattedMessage
                  id={'affordabilityCalculator.beforeStart.warning2'}
                  values={{
                    link: (
                      <a
                        target={'_blank'}
                        rel={'noreferrer'}
                        href={'https://portal.strideup.co/reg/'}
                        className={'text-secondary underline'}
                      >
                        https://portal.strideup.co/reg
                      </a>
                    ),
                  }}
                ></FormattedMessage>
              </p>
              <p className={'m-0'}>
                <FormattedMessage
                  id={'affordabilityCalculator.beforeStart.warning3'}
                  values={{
                    link: (
                      <a
                        target={'_blank'}
                        rel={'noreferrer'}
                        href={'https://strideup.co/'}
                        className={'text-secondary underline'}
                      >
                        https://strideup.co/
                      </a>
                    ),
                  }}
                ></FormattedMessage>
              </p>
            </div>
          </h3>
        </div>
      </div>
    </div>
  );
};
